import React from 'react';

import Layout from '../components/Layout';
import PartialsHeader from '../components/Partials/PartialsHeader';
import Description from '../components/AboutUs/AboutUsDescription';
import LogoSection from '../components/AboutUs/AboutUsLogo';
import Team from '../components/AboutUs/AboutUsTeam';
import Customers from '../components/AboutUs/AboutUsCustomers';
import Culture from '../components/AboutUs/AboutUsCulture';
import Summary from '../components/AboutUs/AboutUsSummary';
import PartialsQuestion from '../components/Partials/PartialsQuestion';

const AboutUs = () => {
  return (
    <Layout
      title="About us | Ulam Labs"
      description="We are a Polish software house that specializes in Python and blockchain technology. Build your product with top notch developers. Hire us!"
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">About us</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <div className="about-us main-view text-format">
        <Description />
        <LogoSection />
        <Team />
        <Customers />
        <Culture />
        <Summary />
      </div>
      <PartialsQuestion />
    </Layout>
  );
};

export default AboutUs;
